import React, { useContext } from 'react';
import Spinner from '../../components/spinner/spinner';
import { PracticePlaceProfileStudent } from './practicePlaceProfileStudent';
import { useParams } from 'react-router-dom';
import { useLoader } from '../../api/useLoader';
import { MenuItemsStudent } from '../../pagelayout/menuitems';
import { StudentApiContext } from '../../api/StudentApiContext';

const PracticePlaceProfilePageStudent: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { id } = useParams<{ id: string }>();
  const { praksisstedApi } = useContext(StudentApiContext);

  const { data, loading } = useLoader(
    async () =>
      praksisstedApi.praksisstedprofilIdGet({ pathParams: { id: id || '' } }),
    [id],
    true,
    true,
  );
  if (!data || loading) {
    return <Spinner />;
  }

  return (
    <PracticePlaceProfileStudent
      data={data}
      menuItems={<MenuItemsStudent />}
      canEdit={false}
      saveHandler={() => {}}
    />
  );
};

export default PracticePlaceProfilePageStudent;
